import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoEnvolvidos } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContratoEnvolvidosService extends BaseResourceService<ContratoEnvolvidos> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-envolvidos`, injector);
  }


  public atualizarEnvolvidosPncp(id: number, cadastrado_pncp: boolean): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/atualizar-envolvidos-pncp`, { id, cadastrado_pncp },
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
